import React, { useRef, useEffect } from "react";
import logo from "../../../assets/img/logo.svg";
import { Link } from 'react-router-dom';

export default function NextMissions() {



    return (
        <div className="next-missions-widget">
            <div>
                <h3>Prochaines missions</h3>
                <span className={"dot"}>1</span>
            </div>
            <Link to={"/mission-list"}>Voir toutes les missions</Link>
            <article>
                <img src={logo} alt="logo" />
                <div>
                    <h4>Hotel fontaine</h4>
                    <p>Adresse</p>
                </div>
                <div>
                    <p>Réceptionniste</p>
                    <p>8h00 <br/> 21 mars 2025</p>
                    <span className={"arrow"}/>
                    <p>16h00 <br/> 21 mars 2025</p>
                </div>
                <Link to={"/mission-detail"}>Voir les détails de la mission</Link>
            </article>
            <article>
                <img src={logo} alt="logo" />
                <div>
                    <h4>Hotel fontaine</h4>
                    <p>Adresse</p>
                </div>
                <div>
                    <p>Réceptionniste</p>
                    <p>8h00 <br/> 21 mars 2025</p>
                    <span className={"arrow"} />
                    <p>16h00 <br/> 21 mars 2025</p>
                </div>
                <Link to="/mission-detail">Voir les détails de la mission</Link>
            </article>
        </div>

    );
}